module.exports = __webpack_public_path__ + "static/media/g-calendar.4d12bfcb.svg";